import { useState } from 'react';
import { useDebounce } from '../../../../../../../../shared/libs/useDebounce';
import {
	useCreateWorkshopTemplateCategory,
} from '../../../../../../../../features/workshop/categories/create/api/useCreateWorkshopTemplateCategory';
import {
	useBindCategoryToWorkshopTemplate,
} from '../../../../../../../../features/workshop/templates/bind-category/api/useBindCategoryToWorkshopTemplate';
import { SearchCategoryBar } from '../../../../../../../../widgets/search-category-bar';
import { ICategoryData } from '../../../../../../../../entities/module/module-category/api/types';
import { IWorkshopTemplate } from '../../../../../../../../entities/template/workshop/template/model/types';
import { workshopCategoryAPI } from '../../../../../../../../entities/template/workshop/tag/api/api';

interface TemplateWorkshopSearchTagBarProps {
	template: IWorkshopTemplate | undefined,
}

export const TemplateWorkshopSearchCategoryBar = ({
	template,
}: TemplateWorkshopSearchTagBarProps) => {
	const [search, setSearch] = useState('');

	const debounceSearch = useDebounce(search.trim(), 200);

	const { data } = workshopCategoryAPI.useGetAllQuery({
		page: 1,
		limit: 127,
		search: debounceSearch,
	});

	const { onCreateCategory } = useCreateWorkshopTemplateCategory();
	const { onBindCategory } = useBindCategoryToWorkshopTemplate(template?.id || '');

	return (
		<SearchCategoryBar
			search={search}
			bindCategory={onBindCategory}
			setSearch={setSearch}
			createCategory={onCreateCategory}
			categories={(data?.templateCategories || []) as ICategoryData[]}
			templateCategories={(template?.categories.fromTemplates || []) as ICategoryData[]}
		/>
	);
};
